const toDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date?.getTime?.()) ? null : date;
};

export const currency = (n, c = "INR") =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: c }).format(
    Number(n || 0)
  );

export const formatDateDMY = (value, fallback = "") => {
  const date = toDate(value);
  if (!date) return fallback;

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatDateDMYUTC = (value, fallback = "") => {
  const date = toDate(value);
  if (!date) return fallback;

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDateTimeDMYUTC = (value, fallback = "") => {
  const date = toDate(value);
  if (!date) return fallback;

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  const h = String(date.getUTCHours()).padStart(2, "0");
  const min = String(date.getUTCMinutes()).padStart(2, "0");
  return `${day}/${month}/${year} ${h}:${min}`;
};

export const formatDateTimeDMY = (value, fallback = "") => {
  const date = toDate(value);
  if (!date) return fallback;

  const datePart = formatDateDMY(date);
  const timePart = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${datePart} ${timePart}`;
};

export const formatBookingNumber = (input) => {
  let raw = "";

  if (typeof input === "string") {
    raw = input;
  } else if (input && typeof input === "object") {
    if (typeof input._id === "string") {
      raw = input._id;
    } else if (input._id && typeof input._id.toString === "function") {
      raw = input._id.toString();
    } else if (typeof input.toString === "function") {
      raw = input.toString();
    }
  }

  if (!raw) return "YB00000";

  const tail = raw.slice(-5);
  const numeric = parseInt(tail, 16);
  const safeNumber = Number.isFinite(numeric) ? numeric % 100000 : 0;

  return `YB${safeNumber.toString().padStart(5, "0")}`;
};
